export function strField(cfg: unknown, key: string): string | undefined {
  if (!cfg || typeof cfg !== 'object') return undefined;
  const v = (cfg as Record<string, unknown>)[key];
  return typeof v === 'string' ? v : undefined;
}

export function arrField(cfg: unknown, key: string): unknown[] {
  if (!cfg || typeof cfg !== 'object') return [];
  const v = (cfg as Record<string, unknown>)[key];
  return Array.isArray(v) ? v : [];
}
